import { Component, Vue, Prop } from 'vue-property-decorator';
import { LabelSetting } from '../../../../../../../../i18n/locale-helper';
import {convertHREF} from "../../../../../../../../utils/util";

@Component({
	template: require('./template.html'),
})
class PrintTemplateComponent extends Vue {
	@Prop()
	data: any
	
	constructor() {
		super();
	}

	get lblSetting() {
		return LabelSetting.Global;
	}

	get lblActionSetting() {
		return LabelSetting.Action;
	}
	
	getConvertHREF(value: string) { return convertHREF(value); }
}

export default PrintTemplateComponent;